<template>
    <div class="ssv-order__container">
        <h2 v-if="headline">{{headline}}</h2>
        <p v-if="description">{{description}}</p>
        <div class="ssv-order">
            <ssv-order-participant-item
                :index="index"
                :key="index"
                :shirt-available="shirtAvailable"
                :distributors="distributors"
                v-for="(c, index) in participants"
            />
            <ssv-order-participant-add/>
            <ssv-order-error-field field="participant.uniquePhones"/>
            <ssv-order-error-field field="participant.uniqueEmails"/>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import map from 'lodash/map';
import isUndefined from 'lodash/isUndefined';
import {isPhone, isEmail} from '../../../helpers/validation';
import SsvOrderParticipantItem from './ParticipantItem';
import SsvOrderParticipantAdd from './ParticipantAdd';
import SsvOrderErrorField from '../error/ErrorField';

export default {
    name:       'SsvOrderParticipantContainer',
    components: {
        SsvOrderErrorField,
        SsvOrderParticipantAdd,
        SsvOrderParticipantItem
    },
    props:      {
        headline:              {
            type:    String,
            default: 'Přihláška účastníků',
        },
        description:           {
            type:    String,
            default: 'Kontaktní údaje účastníků budou použity pro přihlášení do testu na konci kurzu',
        },
        shirtAvailable:   {
            type:    Boolean,
            require: false,
            default: () => false,
        },
        distributors:   {
            type:    Boolean,
            require: false,
            default: () => false,
        },
        checkDuplicatedEmails: {
            type:    Boolean,
            require: false,
            default: () => false,
        }
    },
    computed:   {
        ...mapGetters('ssvOrder', ['participants']),
    },
    methods:    {
        ...mapActions('ssvOrder', ['setError']),
        validate() {
            let uniquePhone = {};
            let uniqueEmails = {};
            map(this.participants, ({ name, surname, phone, email, additionalData: { shirt, role } }, index) => {
                if (!name || name.length === 0) this.setError({
                    msg: 'Zadejte jméno účastníka',
                    key: `participant.${index}.name`
                });
                if (!surname || surname.length === 0) this.setError({
                    msg: 'Zadejte přijmení účastníka',
                    key: `participant.${index}.surname`
                });
                if (!phone || phone.length === 0) this.setError({
                    msg: 'Zadejte telefon účastníka',
                    key: `participant.${index}.phone`
                });
                if (phone && phone.length !== 0 && !isPhone(phone)) this.setError({
                    msg: 'Zadaný telefon není v ideální kondici',
                    key: `participant.${index}.phone`
                });
                if (!email || email.length === 0) this.setError({
                    msg: 'Zadejte e-mail účastníka',
                    key: `participant.${index}.email`
                });
                if (email && email.length !== 0 && !isEmail(email)) this.setError({
                    msg: 'Zadaný e-mail není v ideální kondici',
                    key: `participant.${index}.email`
                });
                if (this.shirtAvailable && (isUndefined(shirt) || !shirt)) this.setError({
                    msg: 'Vyberte velikost trika',
                    key: `participant.${index}.shirt`
                });
                if (this.distributors && (isUndefined(role) || !role)) this.setError({
                    msg: 'Vyberte funkci',
                    key: `participant.${index}.role`
                });
                uniquePhone[phone] = true;
                uniqueEmails[email] = true;
            });

            if (this.participants.length > 1 && Object.keys(uniquePhone).length !== this.participants.length) this.setError({
                msg: 'Telefonní čísla účastníků nemohou být stejná.<br>Zadejte prosím telefonní čísla každého z účastníků a odešlete formulář znovu.',
                key: `participant.uniquePhones`
            })
            if (this.participants.length > 1 && Object.keys(uniqueEmails).length !== this.participants.length && this.checkDuplicatedEmails) this.setError({
                msg: 'E-maily účastníků nemohou být stejné.<br>Zadejte prosím e-mail každého z účastníků a odešlete formulář znovu.',
                key: `participant.uniqueEmails`
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/participant/ParticipantContainer.vue